<template>
    <div style="background-color: #f9f9f9;">
        <Header />
        <div class="container">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item @click.native="$router.go(-1)">采购大厅</el-breadcrumb-item>
                    <el-breadcrumb-item>采购单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <!-- 采购商信息 -->
            <div class="purchase-info">
                <div class="info-header">
                    <span class="blue-line"></span>
                    <div class="info-title">采购商信息</div>
                    <span class="end-time">21:15:02后结束</span>
                </div>
                <div class="info-content">
                    <div class="title">{{ purchaseDetails.title }}</div>
                    <div class="requirement">
                        <span>采购要求：</span>
                        <span>{{ purchaseDetails.needs }}</span>
                    </div>
                    <div class="info-row">
                        <span>结算周期：{{ purchaseDetails.settle_type_name }}</span>
                        <span>收货地址：{{ purchaseDetails.address_info.detail }}</span>
                    </div>
                </div>
            </div>
            <!-- 采购商品 -->
            <div class="purchase-info">
                <div class="info-header">
                    <span class="blue-line"></span>
                    <div class="info-title">采购商品</div>
                </div>
                <el-table :data="purchaseDetails.goods_list" border style="width: 100%">
                    <el-table-column prop="name" label="商品名称" />
                    <el-table-column prop="num" label="采购数量" />
                    <el-table-column label="可接受采购误差">
                        <template slot-scope="scope">
                            ±{{ scope.row.error_range }}{{ scope.row.unit }}
                        </template>
                    </el-table-column>
                    <el-table-column label="平台参考价">
                        <template slot-scope="scope">
                            {{ scope.row.refer_price }}{{ scope.row.unit }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 立即报价按钮 -->
            <div class="quote-btn-container">
                <button class="quote-btn" @click="toQuote">立即报价</button>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
export default {
    name: 'PurchaseDetails',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            aid: '',
            purchaseDetails: {
                address_info: {
                    detail: ''
                },
                needs: '',
                settle_type_name: '',
                title: '',
                goods_list: []
            }
        }
    },
    mounted() {
        this.aid = this.$route.query.aid;
        this.getPurchaseDetails();
    },
    methods: {
        // 立即报价
        toQuote() {
            this.$api.isPurchase({
                purchaselist_id: this.aid
            }).then(res => {
                this.$router.push({
                    path: '/PurchaseQuotation',
                    query: { aid: this.aid }
                })
            }).catch(err => {
                this.$message.error(err);
            })
        },
        getPurchaseDetails() {
            this.$api.purchaseDetails({
                aid: this.aid
            }).then(res => {
                this.purchaseDetails = res;
            }).catch(err => {
                this.$message.error(err);
            })
        }
    }
}

</script>

<style scoped>
.container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
    color: #666;
}

.breadcrumb .active {
    color: #333;
    font-weight: bold;
}

.arrow {
    margin: 0 5px;
}

.purchase-info,
.purchase-products {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

.info-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.info-title {
    font-size: 16px;
    margin: 0;
    font-weight: bold;
}

.blue-line {
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #1890ff;
    margin-right: 8px;
    vertical-align: middle;
}

.end-time {
    color: #ff4d4f;
    font-size: 14px;
    margin-left: 20px;
}

.info-content {
    line-height: 1.6;
    text-align: left;
}

.title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.requirement {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.requirement span:first-child {
    margin-right: 5px;
}

.info-row {
    display: flex;
    gap: 30px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.products-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
}

.products-table th,
.products-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e8e8e8;
}

.products-table th {
    background-color: #f0f0f0;
    font-weight: bold;
}

.product-name {
    color: #1890ff;
}

.quote-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.quote-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 40px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.quote-btn:hover {
    background-color: #40a9ff;
}
</style>